import { render } from "./save-icon.vue?vue&type=template&id=606f6200"
import script from "./save-icon.vue?vue&type=script&lang=js"
export * from "./save-icon.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__